import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, TrendingUp, Target, Users, ArrowRight } from 'lucide-react';

export const ResourcesSection: React.FC = () => {
  const resources = [
    {
      icon: <TrendingUp className="h-6 w-6 text-primary-600" />,
      title: "Trading Journal Software Comparison",
      description: "Compare the top trading journal platforms and see why Simplified Trading Journal is the best choice for traders.",
      link: "/comprehensive-trading-journal-comparison"
    },
    {
      icon: <Target className="h-6 w-6 text-primary-600" />,
      title: "Best Trading Journal Software 2025",
      description: "Our comprehensive ranking of the top trading journal software platforms with detailed reviews and analysis.",
      link: "/best-trading-journal-software-2025"
    },
    {
      icon: <BookOpen className="h-6 w-6 text-primary-600" />,
      title: "Trading Education Hub",
      description: "Learn trading strategies, risk management, and journal best practices to improve your trading performance.",
      link: "/resources",
      comingSoon: true
    },
    {
      icon: <Users className="h-6 w-6 text-primary-600" />,
      title: "Trading Psychology Guides",
      description: "Master the mental side of trading with our comprehensive guides on discipline, emotions, and habit formation.",
      link: "/resources",
      comingSoon: true
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Trading Resources & Guides
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our comprehensive collection of trading guides, comparisons, and educational content to improve your trading performance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {resources.map((resource, index) => (
            <div key={index} className="group relative bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <div className="flex items-center justify-center w-12 h-12 bg-primary-100 rounded-lg mb-4">
                {resource.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {resource.title}
              </h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                {resource.description}
              </p>
              {resource.comingSoon ? (
                <span className="text-sm text-gray-500 font-medium">Coming Soon</span>
              ) : (
                <Link
                  to={resource.link}
                  className="text-primary-600 hover:text-primary-700 font-medium text-sm inline-flex items-center group-hover:underline"
                >
                  Read More →
                </Link>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/resources"
            className="inline-flex items-center justify-center px-8 py-3 bg-black hover:bg-gray-900 text-white font-medium rounded-full shadow-md hover:shadow-lg transition-all duration-300 md:py-4 md:text-lg md:px-10"
          >
            See All Resources
            <ArrowRight size={20} className="ml-2" />
          </Link>
        </div>
      </div>
    </section>
  );
};